/**
 * Trigger: tr_incomes_soft_delete
 * Purpose: Update account balances when an income is soft deleted or restored
 * Table: incomes
 * Event: UPDATE OF is_deleted
 */
export const TR_INCOMES_SOFT_DELETE = `
CREATE TRIGGER tr_incomes_soft_delete
UPDATE OF is_deleted ON incomes
WHEN new.is_deleted <> old.is_deleted
BEGIN
  UPDATE account_balances
  SET incomes_amount = CASE
    WHEN new.is_deleted = 0 THEN incomes_amount + old.amount
    ELSE incomes_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET incomes_amount = CASE
    WHEN new.is_deleted = 0 THEN incomes_amount + old.amount
    ELSE incomes_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.income_date;

  -- Delete only THIS specific daily balance record if all amounts are zero
  -- (instead of scanning entire table)
  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.income_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  -- Delete only THIS specific activity date record if no balances exist
  -- (instead of scanning entire table with NOT EXISTS)
  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND activity_date = old.income_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_daily_balances.account_id = old.account_id
        AND account_daily_balances.balance_date = old.income_date
      LIMIT 1
    );
END;
`;
